import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthGuardData, createAuthGuard } from 'keycloak-angular';
import Keycloak from 'keycloak-js';

const REDIRECT_URI_PATH = '/adressök';

export const isAccessAllowed = async (
  _route: ActivatedRouteSnapshot,
  _state: RouterStateSnapshot,
  authData: AuthGuardData
): Promise<boolean> => {
  const keycloak = inject(Keycloak);

  if (!authData.authenticated) {
    await keycloak.login({
      redirectUri: window.location.origin + REDIRECT_URI_PATH,
    });
  }

  return authData.authenticated;
};

export const AuthGuard = createAuthGuard<CanActivateFn>(isAccessAllowed);
